import styled from '@emotion/styled';
import {
  MIRA_UNPAID_LAYOUT_TEXT_PC_FONT_SIZE,
  MIRA_UNPAID_LAYOUT_TEXT_PC_LETTER_SPACING,
  MIRA_UNPAID_LAYOUT_TEXT_PC_LINE_HEIGHT,
  MIRA_UNPAID_LAYOUT_TEXT_TABLET_FONT_SIZE,
  MIRA_UNPAID_LAYOUT_TEXT_TABLET_LETTER_SPACING,
  MIRA_UNPAID_LAYOUT_TEXT_TABLET_LINE_HEIGHT,
  MIRA_UNPAID_LAYOUT_TEXT_SMART_LETTER_SPACING,
  MIRA_UNPAID_LAYOUT_TEXT_SMART_LINE_HEIGHT,
  MIRA_UNPAID_LAYOUT_TEXT_SMART_FONT_SIZE,
  MIRA_UNPAID_LAYOUT_PC_MARGIN_TOP,
  MIRA_UNPAID_LAYOUT_TABLET_MARGIN_TOP,
  MIRA_UNPAID_LAYOUT_SMART_MARGIN_TOP,
  MIRA_UNPAID_LAYOUT_MARGIN_BOTTOM,
  MIRA_UNPAID_LAYOUT_PC_MAX_WIDTH,
  MIRA_UNPAID_LAYOUT_TABLET_SMART_MAX_WIDTH,
  MAIN_FULL_WIDTH,
  ERROR_DESCRIPTION,
  ERROR_DESCRIPTION_MARGIN_BOTTOM,
  ERROR_SMART_DESCRIPTION,
  MIRA_PAYMENT_LAYOUT_PC_BUTTON_MARGIN_TOP,
  MIRA_PAYMENT_LAYOUT_TABLET_BUTTON_MARGIN_TOP,
  MIRA_PAYMENT_LAYOUT_SMART_BUTTON_MARGIN_BOTTOM,
  MAIN_SMART_LAYOUT_MARGIN_RIGHT,
  MAIN_SMART_LAYOUT_MARGIN_LEFT,
  MIRA_PAYMENT_LAYOUT_SMART_BUTTON_IPHONE_MARGIN_BOTTOM,
  MIRA_RECESS_LAYOUT_TITLE_FONT_WEIGHT,
} from '../../../styles/size';
import { IPHONE_SIZE, SMART_SIZE, TABLET_SIZE } from '../../../styles/common';
import { BLACK } from '../../../styles/color';

export const Layout = styled.div`
  margin-top: ${MIRA_UNPAID_LAYOUT_PC_MARGIN_TOP};
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: ${MIRA_UNPAID_LAYOUT_MARGIN_BOTTOM};
  & > div {
    & > div {
      max-width: ${MIRA_UNPAID_LAYOUT_PC_MAX_WIDTH};
      margin-left: auto;
      margin-right: auto;
      & > h1 {
        font-size: ${MIRA_UNPAID_LAYOUT_TEXT_PC_FONT_SIZE};
        line-height: ${MIRA_UNPAID_LAYOUT_TEXT_PC_LINE_HEIGHT};
        letter-spacing: ${MIRA_UNPAID_LAYOUT_TEXT_PC_LETTER_SPACING};
        color: ${BLACK};
        font-weight: ${MIRA_RECESS_LAYOUT_TITLE_FONT_WEIGHT};
      }
    }
  }
  ${TABLET_SIZE} {
    margin-top: ${MIRA_UNPAID_LAYOUT_TABLET_MARGIN_TOP};
    & > div {
      width: 100%;
      & > div {
        max-width: ${MIRA_UNPAID_LAYOUT_TABLET_SMART_MAX_WIDTH};
        margin-left: auto;
        margin-right: auto;
        & > h1 {
          font-size: ${MIRA_UNPAID_LAYOUT_TEXT_TABLET_FONT_SIZE};
          line-height: ${MIRA_UNPAID_LAYOUT_TEXT_TABLET_LINE_HEIGHT};
          letter-spacing: ${MIRA_UNPAID_LAYOUT_TEXT_TABLET_LETTER_SPACING};
          color: ${BLACK};
          font-weight: ${MIRA_RECESS_LAYOUT_TITLE_FONT_WEIGHT};
        }
      }
    }
  }
  ${SMART_SIZE} {
    margin-top: ${MIRA_UNPAID_LAYOUT_SMART_MARGIN_TOP};
    & > div {
      width: ${MAIN_FULL_WIDTH};
      & div {
        & > h1 {
          width: calc(${MAIN_FULL_WIDTH} - ${MAIN_SMART_LAYOUT_MARGIN_LEFT} - ${MAIN_SMART_LAYOUT_MARGIN_RIGHT});
          font-size: ${MIRA_UNPAID_LAYOUT_TEXT_SMART_FONT_SIZE};
          line-height: ${MIRA_UNPAID_LAYOUT_TEXT_SMART_LINE_HEIGHT};
          letter-spacing: ${MIRA_UNPAID_LAYOUT_TEXT_SMART_LETTER_SPACING};
          color: ${BLACK};
          font-weight: ${MIRA_RECESS_LAYOUT_TITLE_FONT_WEIGHT};
        }
      }
    }
  }
`;

export const ErrorMessageDescription = styled.p`
  font-size: ${ERROR_DESCRIPTION};
  margin-bottom: ${ERROR_DESCRIPTION_MARGIN_BOTTOM};
  line-height: 1.5;
  white-space: pre-line;
  ${SMART_SIZE}: {
    font-size: ${ERROR_SMART_DESCRIPTION};
  }
`;

export const Buttonside = styled.div`
  margin-top: ${MIRA_PAYMENT_LAYOUT_PC_BUTTON_MARGIN_TOP};
  ${TABLET_SIZE} {
    margin-top: ${MIRA_PAYMENT_LAYOUT_TABLET_BUTTON_MARGIN_TOP};
  }
  ${SMART_SIZE} {
    position: absolute;
    bottom: ${MIRA_PAYMENT_LAYOUT_SMART_BUTTON_MARGIN_BOTTOM};
    width: calc(${MAIN_FULL_WIDTH} - ${MAIN_SMART_LAYOUT_MARGIN_LEFT} - ${MAIN_SMART_LAYOUT_MARGIN_RIGHT});
  }
  ${IPHONE_SIZE} {
    bottom: ${MIRA_PAYMENT_LAYOUT_SMART_BUTTON_IPHONE_MARGIN_BOTTOM};
  }
`;
